import React, { useEffect } from 'react';
import './wheelmodal.css';
import WheelProfile from './wheelprofile';

const WheelModal = ({ showModal, toggleModal, wheel, onWheelUpdated, onWheelDeleted }) => {
  useEffect(() => {
    const appElement = document.querySelector('.App');
    if (showModal) {
      appElement?.classList.add('wheelmodal-open');
    } else {
      appElement?.classList.remove('wheelmodal-open');
    }
    return () => {
      appElement?.classList.remove('wheelmodal-open');
    };
  }, [showModal]);

  if (!showModal || !wheel) return null;

  const handleClose = (updatedWheel) => {
    if (updatedWheel && onWheelUpdated) {
      onWheelUpdated(updatedWheel);
    }
    toggleModal();
  };

  const handleDeleted = (wheelId) => {
    if (onWheelDeleted) onWheelDeleted(wheelId);
    toggleModal();
  };

  return (
    <div className="wheelmodal-overlay">
      <div className="wheelmodal-content">
        <WheelProfile
          wheel={wheel}
          onClose={handleClose}
          onWheelUpdated={onWheelUpdated}
          onWheelDeleted={handleDeleted}
        />
      </div>
    </div>
  );
};

export default WheelModal;
